import React, { useState } from 'react';
import { Mic, Volume2, Pause, Play, Headphones, Settings, ChevronRight, X } from 'lucide-react';
const VoiceAILayer: React.FC = () => {
  const [isListening, setIsListening] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [voiceType, setVoiceType] = useState('seductive');
  const [voiceAccent, setVoiceAccent] = useState('american');
  const [recentMessages, setRecentMessages] = useState(["I've been thinking about you all day...", 'Would you like to hear about my fantasy?', "Tell me what you're wearing right now"]);
  return <div className="w-full bg-white dark:bg-gray-950 text-gray-800 dark:text-white pb-20" data-id="element-22409">
      {/* Header */}
      <div className="p-4 border-b border-gray-200 dark:border-gray-800" data-id="element-22410">
        <div className="flex items-center gap-3 mb-4" data-id="element-22411">
          <div className="w-10 h-10 rounded-full bg-gradient-to-r from-pink-500 to-purple-500 flex items-center justify-center" data-id="element-22412">
            <Headphones size={20} className="text-white" data-id="element-22413" />
          </div>
          <div data-id="element-22414">
            <h2 className="text-xl font-bold text-gray-800 dark:text-white" data-id="element-22415">
              Voice AI
            </h2>
            <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-22416">
              Talk with your angels using your voice
            </p>
          </div>
          <button className="ml-auto p-2 rounded-full bg-gray-100 dark:bg-gray-800" onClick={() => setShowSettings(!showSettings)} data-id="element-22417">
            <Settings size={18} className="text-gray-600 dark:text-gray-400" data-id="element-22418" />
          </button>
        </div>
        {/* Voice settings panel */}
        {showSettings && <div className="mb-4 p-3 bg-gray-50 dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-800 animate-in slide-in-from-top duration-300" data-id="element-22419">
            <div className="flex justify-between items-center mb-3" data-id="element-22420">
              <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300" data-id="element-22421">
                Voice Settings
              </h3>
              <button className="p-1 rounded-full hover:bg-gray-200 dark:hover:bg-gray-800" onClick={() => setShowSettings(false)} data-id="element-22422">
                <X size={16} className="text-gray-500 dark:text-gray-400" data-id="element-22423" />
              </button>
            </div>
            <div className="mb-3" data-id="element-22424">
              <label className="block text-xs text-gray-600 dark:text-gray-400 mb-1" data-id="element-22425">
                Voice Type
              </label>
              <div className="grid grid-cols-3 gap-2" data-id="element-22426">
                {['seductive', 'playful', 'dominant'].map(type => <button key={type} className={`p-2 rounded-lg text-xs capitalize ${voiceType === type ? 'bg-pink-500 text-white' : 'bg-gray-200 dark:bg-gray-800 text-gray-700 dark:text-gray-300'}`} onClick={() => setVoiceType(type)} data-id="element-22427">
                    {type}
                  </button>)}
              </div>
            </div>
            <div data-id="element-22428">
              <label className="block text-xs text-gray-600 dark:text-gray-400 mb-1" data-id="element-22429">
                Accent
              </label>
              <div className="grid grid-cols-3 gap-2" data-id="element-22430">
                {['american', 'british', 'australian'].map(accent => <button key={accent} className={`p-2 rounded-lg text-xs capitalize ${voiceAccent === accent ? 'bg-pink-500 text-white' : 'bg-gray-200 dark:bg-gray-800 text-gray-700 dark:text-gray-300'}`} onClick={() => setVoiceAccent(accent)} data-id="element-22431">
                    {accent}
                  </button>)}
              </div>
            </div>
          </div>}
        {/* Voice visualization */}
        <div className="p-4 bg-gray-100 dark:bg-gray-900 rounded-lg mb-4" data-id="element-22432">
          <div className="flex items-center justify-center mb-3" data-id="element-22433">
            <div className="relative" data-id="element-22434">
              <div className="w-24 h-24 rounded-full bg-gradient-to-r from-pink-500 to-purple-500 flex items-center justify-center relative overflow-hidden" data-id="element-22435">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bU73WvXeTZLjt1PKcu9KyE/image.png" alt="Sophia" className="w-full h-full object-cover opacity-80" data-id="element-22436" />
                {/* Voice wave animation */}
                {isListening && <div className="absolute inset-0 flex items-center justify-center" data-id="element-22437">
                    <div className="flex items-end space-x-1" data-id="element-22438">
                      {[0.3, 0.5, 0.8, 0.5, 0.3, 0.5, 0.8, 0.5, 0.3].map((height, i) => <div key={i} className="w-1 bg-white rounded-full opacity-70" style={{
                    height: `${height * 40}px`,
                    animation: `voice-wave 0.6s infinite alternate ${i * 0.1}s`
                  }} data-id="element-22439"></div>)}
                    </div>
                  </div>}
              </div>
              {/* Status indicator */}
              <div className={`absolute bottom-0 right-0 w-6 h-6 rounded-full flex items-center justify-center ${isListening ? 'bg-red-500' : isPlaying ? 'bg-green-500' : 'bg-gray-400'} border-2 border-white dark:border-gray-900`} data-id="element-22440">
                {isListening ? <Mic size={12} className="text-white" data-id="element-22441" /> : isPlaying ? <Volume2 size={12} className="text-white" data-id="element-22442" /> : <Pause size={12} className="text-white" data-id="element-22443" />}
              </div>
            </div>
          </div>
          <p className="text-center text-sm text-gray-600 dark:text-gray-400" data-id="element-22444">
            {isListening ? "I'm listening..." : isPlaying ? "I'm speaking..." : 'Tap the microphone to start'}
          </p>
        </div>
        {/* Voice control buttons */}
        <div className="flex justify-center space-x-4 mb-4" data-id="element-22445">
          <button className={`w-16 h-16 rounded-full flex items-center justify-center ${isListening ? 'bg-red-500' : 'bg-gradient-to-r from-pink-600 to-purple-600'} shadow-lg`} onClick={() => setIsListening(!isListening)} data-id="element-22446">
            <Mic size={24} className="text-white" data-id="element-22447" />
          </button>
          <button className={`w-16 h-16 rounded-full flex items-center justify-center ${isPlaying ? 'bg-green-500' : 'bg-gray-200 dark:bg-gray-800'}`} onClick={() => setIsPlaying(!isPlaying)} data-id="element-22448">
            {isPlaying ? <Pause size={24} className="text-white" data-id="element-22449" /> : <Play size={24} className="text-gray-700 dark:text-gray-300" data-id="element-22450" />}
          </button>
        </div>
      </div>
      {/* Recent voice messages */}
      <div className="p-4" data-id="element-22451">
        <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2" data-id="element-22452">
          Recent Voice Messages
        </h3>
        <div className="space-y-2" data-id="element-22453">
          {recentMessages.map((message, index) => <div key={index} className="p-3 bg-gray-100 dark:bg-gray-900 rounded-lg flex items-center justify-between" data-id="element-22454">
              <p className="text-sm text-gray-700 dark:text-gray-300" data-id="element-22455">
                {message}
              </p>
              <button className="p-2 rounded-full hover:bg-gray-200 dark:hover:bg-gray-800" data-id="element-22456">
                <Play size={16} className="text-gray-600 dark:text-gray-400" data-id="element-22457" />
              </button>
            </div>)}
        </div>
        <div className="mt-4" data-id="element-22458">
          <button className="w-full p-3 bg-gray-100 dark:bg-gray-900 rounded-lg text-sm text-gray-700 dark:text-gray-300 flex items-center justify-between" data-id="element-22459">
            <span data-id="element-22460">View all voice messages</span>
            <ChevronRight size={16} className="text-gray-500 dark:text-gray-400" data-id="element-22461" />
          </button>
        </div>
      </div>
      {/* Premium features */}
      <div className="mx-4 mt-6 p-4 bg-gradient-to-r from-pink-900/30 to-purple-900/30 rounded-lg border border-pink-800/30" data-id="element-22462">
        <h3 className="font-medium text-gray-800 dark:text-white mb-2" data-id="element-22463">
          Premium Voice Features
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-300 mb-3" data-id="element-22464">
          Unlock advanced voice capabilities with premium subscription
        </p>
        <div className="space-y-2 mb-3" data-id="element-22465">
          <div className="flex items-center gap-2" data-id="element-22466">
            <div className="w-4 h-4 rounded-full bg-pink-500 flex items-center justify-center" data-id="element-22467">
              <span className="text-white text-[8px]" data-id="element-22468">✓</span>
            </div>
            <span className="text-sm text-gray-700 dark:text-gray-300" data-id="element-22469">
              Custom voice personalities
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-22470">
            <div className="w-4 h-4 rounded-full bg-pink-500 flex items-center justify-center" data-id="element-22471">
              <span className="text-white text-[8px]" data-id="element-22472">✓</span>
            </div>
            <span className="text-sm text-gray-700 dark:text-gray-300" data-id="element-22473">
              Extended voice conversations
            </span>
          </div>
          <div className="flex items-center gap-2" data-id="element-22474">
            <div className="w-4 h-4 rounded-full bg-pink-500 flex items-center justify-center" data-id="element-22475">
              <span className="text-white text-[8px]" data-id="element-22476">✓</span>
            </div>
            <span className="text-sm text-gray-700 dark:text-gray-300" data-id="element-22477">
              Voice message recording
            </span>
          </div>
        </div>
        <button className="w-full py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white text-sm font-medium" data-id="element-22478">
          Upgrade to Premium
        </button>
      </div>
      <style jsx data-id="element-22479">{`
        @keyframes voice-wave {
          0% {
            transform: scaleY(0.5);
          }
          100% {
            transform: scaleY(1);
          }
        }
      `}</style>
    </div>;
};
export default VoiceAILayer;